import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        BOX: 'КИТУ',
        GROUP: 'КИГУ',
        PRODUCT_SET: 'КИН',
      },
    }
  }
}
